// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

export const UserType = Object.freeze({
  Admin: "Admin",
});

// ==============================
// Order Domain Constants
// ==============================
export const ORDER_STATUS = Object.freeze({
  INITIATED: "INITIATED",
  PAID: "PAID",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
});

export const PRICING_MODEL = Object.freeze({
  FIXED: "FIXED",
  TENURE_BASED: "TENURE_BASED",
  SUBSCRIPTION: "SUBSCRIPTION",
});
